import React from 'react';
import { Box, Typography } from '@mui/material';
import MentalHealthAssessmentComponent from '../../components/MentalHealthAssessment';

const MentalHealthAssessment = ({ patientId }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Mental Health Assessment
      </Typography>
      <MentalHealthAssessmentComponent patientId={patientId} />
    </Box>
  );
};

export default MentalHealthAssessment; 